import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import ChatInterface from './components/ChatInterface';
import theme from './theme';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { LoadingOverlay } from './components/SharedComponents'
import SuperAdminDashboard from './components/SuperAdminDashboard';
import SuperAdmin from './components/SuperAdmin';
const Login = React.lazy(() => import('./components/Login'));
const ChangePassword = React.lazy(() => import('./components/ChangePassword'));
import TokenLogin from './components/TokenLogin';
import WordPressSSOHandler from './components/WordPressSSOHandler';

const AuthRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <LoadingOverlay />
    );
  }

  if (user) {
    if (user.must_change_password) {
      return <Navigate to="/change-password" replace />;
    }
    return <Navigate to="/chat" replace />;
  }

  return children;
};

const ProtectedAppRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingOverlay />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }
  if (user.must_change_password) {
    return <Navigate to="/change-password" replace />;
  }
  return children;
};

const ChangePasswordRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingOverlay />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const App = () => {
  return (
      <AuthProvider>
    <ChakraProvider theme={theme}>
        <Router>
          <React.Suspense fallback={<LoadingOverlay />}>
            <Routes>
              <Route path="/login" element={<AuthRoute><Login /></AuthRoute>} />
              <Route path="/change-password" element={<ChangePasswordRoute><ChangePassword /></ChangePasswordRoute>} />
              <Route path="/wordpress-sso" element={<WordPressSSOHandler />} />
              <Route path="/auth/token" element={<TokenLogin />} />
              <Route path="/chat/:conversationId" element={<ProtectedAppRoute><ChatInterface /></ProtectedAppRoute>} />
              <Route path="/chat" element={<ProtectedAppRoute><ChatInterface /></ProtectedAppRoute>} />
              <Route path="/superadmin" element={<ProtectedAppRoute><SuperAdmin /></ProtectedAppRoute>} />
              <Route path="/superadmin/dashboard" element={<ProtectedAppRoute><SuperAdminDashboard /></ProtectedAppRoute>} />
              <Route path="/" element={<Navigate to="/chat" replace />} />
            </Routes>
          </React.Suspense>
        </Router>
    </ChakraProvider>
    </AuthProvider>
  );
};

export default App; 
